import { useRef } from "react";

const useCommentDraftSession = () => {
    const sessionCounterRef = useRef(0);
    const sessionsRef = useRef({});

    const startAddSession = () => {
        sessionCounterRef.current += 1;
        const id = sessionCounterRef.current;

        sessionsRef.current[id] = {
            draftId: null,
            shouldCleanup: false,
            attachmentIds: {}
        };

        return id;
    };

    const getSession = (sessionId) => {
        return sessionsRef.current[sessionId] || null;
    };

    const registerDraft = (sessionId, draftId) => {
        const session = getSession(sessionId);

        if (!session) {
            return null;
        }

        session.draftId = Number(draftId);
        return session.draftId;
    };

    const getDraftId = (sessionId) => {
        return getSession(sessionId)?.draftId || null;
    };

    const markShouldCleanupDraft = (sessionId) => {
        const session = getSession(sessionId);

        if (session) {
            session.shouldCleanup = true;
        }
    };

    const shouldCleanupDraftAfterCreate = (sessionId) => {
        return !!getSession(sessionId)?.shouldCleanup;
    };

    const addAttachment = (sessionId, attachmentId) => {
        const session = getSession(sessionId);

        if (session && attachmentId) {
            session.attachmentIds[Number(attachmentId)] = true;
        }
    };

    const removeAttachment = (sessionId, attachmentId) => {
        const session = getSession(sessionId);

        if (session && attachmentId) {
            delete session.attachmentIds[Number(attachmentId)];
        }
    };

    const getAttachmentIds = (sessionId) => {
        const session = getSession(sessionId);

        if (!session) {
            return [];
        }

        return Object.keys(session.attachmentIds).map(Number);
    };

    const clearSession = (sessionId) => {
        delete sessionsRef.current[sessionId];
    };

    return {
        startAddSession,
        registerDraft,
        getDraftId,
        markShouldCleanupDraft,
        shouldCleanupDraftAfterCreate,
        addAttachment,
        removeAttachment,
        getAttachmentIds,
        clearSession
    };
};

export default useCommentDraftSession;
